const valueFor = (source, ...keys) => {
  const object = source || {};
  return keys.find(key => object[key] !== undefined)
    ? object[keys.find(key => object[key] !== undefined)]
    : undefined;
};

export const operationalRuntimeForVisit = visit =>
  valueFor(visit, 'operationalRuntime', 'operational_runtime') || {};

export const runtimeSummaryForVisit = visit =>
  valueFor(operationalRuntimeForVisit(visit), 'summary') || {};

export const runtimeMatrixForVisit = visit =>
  valueFor(operationalRuntimeForVisit(visit), 'matrix') || [];

export const runtimeEventsForVisit = visit =>
  valueFor(operationalRuntimeForVisit(visit), 'events') || [];

export const runtimeAnalyticsEventsForVisit = visit =>
  valueFor(
    operationalRuntimeForVisit(visit),
    'analyticsEvents',
    'analytics_events'
  ) || [];

export const RUNTIME_TONE_CLASSES = Object.freeze({
  success: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  warning: 'border-amber-200 bg-amber-50 text-amber-800',
  critical: 'border-rose-200 bg-rose-50 text-rose-800',
  neutral: 'border-lais-border bg-lais-bg-soft text-lais-text-body',
});

export const RUNTIME_STATE_BADGES = Object.freeze({
  healthy: {
    tone: 'success',
    icon: 'i-lucide-circle-check',
    label: 'Runtime saudável',
  },
  in_progress: {
    tone: 'warning',
    icon: 'i-lucide-loader-circle',
    label: 'Jobs em andamento',
  },
  attention: {
    tone: 'critical',
    icon: 'i-lucide-triangle-alert',
    label: 'Atenção operacional',
  },
  no_events: {
    tone: 'neutral',
    icon: 'i-lucide-circle-dashed',
    label: 'Sem eventos runtime',
  },
});

export const runtimeStatusLabel = entry =>
  valueFor(entry, 'statusLabel', 'status_label') ||
  valueFor(entry, 'status') ||
  'Pendente';

export const runtimeToneClass = tone =>
  RUNTIME_TONE_CLASSES[tone] || RUNTIME_TONE_CLASSES.neutral;

export const runtimeBadgeForVisit = visit => {
  const summary = runtimeSummaryForVisit(visit);
  const state = valueFor(summary, 'state') || 'no_events';
  const badge = RUNTIME_STATE_BADGES[state] || RUNTIME_STATE_BADGES.no_events;
  const lastEventAt = valueFor(summary, 'lastEventAt', 'last_event_at');
  const attentionCount = Number(
    valueFor(summary, 'attentionCount', 'attention_count') || 0
  );
  const queuedCount = Number(
    valueFor(summary, 'queuedCount', 'queued_count') || 0
  );

  return {
    ...badge,
    state,
    label: valueFor(summary, 'label') || badge.label,
    lastEventAt,
    attentionCount,
    queuedCount,
    title: [
      valueFor(summary, 'label') || badge.label,
      lastEventAt ? `Último evento: ${lastEventAt}` : '',
      attentionCount ? `${attentionCount} alerta(s)` : '',
      queuedCount ? `${queuedCount} em fila/execução` : '',
    ]
      .filter(Boolean)
      .join(' · '),
  };
};

export const runtimeEventDigest = entry => {
  const eventKey = valueFor(entry, 'eventKey', 'event_key');
  const queue = valueFor(entry, 'queue');
  const attemptCount = valueFor(entry, 'attemptCount', 'attempt_count') || 0;
  const deliveryStatus =
    valueFor(entry, 'deliveryStatus', 'delivery_status') ||
    valueFor(entry, 'status');
  return {
    eventKey,
    queue,
    attemptCount,
    deliveryStatus,
    payloadSha256: valueFor(entry, 'payloadSha256', 'payload_sha256'),
    lastAttemptAt: valueFor(entry, 'lastAttemptAt', 'last_attempt_at'),
  };
};
